<!-- <p>address works!</p> -->
<div class="address_cont {{isCheckoutPage?'for_checkout':''}}">

	<div class="inner_address_cont shipping_address_cont {{isAddShippingButtonClicked?'address_type_active':''}}">
		<h3>Shipping Address Book</h3>
		<p>Set Shipping address</p>
		<button (click)="openAddressPopup('add', false, false)">
			<span class="plus_icon material-symbols-outlined">add</span>
			<span class="button_text">Add Address</span>
		</button>
		<div class="address_list_cont" *ngIf="shippingAddress">
			<ng-container *ngFor="let address of shippingAddress; let i = index ">
				<ng-container *ngIf="address.addressType==='SHIPPING'">
					<fb-address-list (defaultAddressUpdate)="reloadList()"
									 (editAddress)="passDataInForm($event)"
									 (deleteAddress)="deleteAddress($event, address.addressType, i)"
									 [addressData]="address"></fb-address-list>
				</ng-container>
			</ng-container>
		</div>
	</div>

	<div class="inner_address_cont billing_address_cont {{!isAddShippingButtonClicked?'address_type_active':''}}">
		<h3>Billing Address Book</h3>
		<p>Set Billing address</p>
		<button (click)="openAddressPopup('add', false, true)">
			<span class="plus_icon material-symbols-outlined">add</span>
			<span class="button_text">Add Address</span>
		</button>

		<div class="address_list_cont" *ngIf="billingAddress.length>0">
			<ng-container *ngFor="let address of billingAddress; let i = index ">
				<ng-container *ngIf="address.addressType==='BILLING'">
					<fb-address-list
						[addressData]="address"
						(defaultAddressUpdate)="reloadList()"
						(deleteAddress)="deleteAddress($event, address.addressType, i)"
						(editAddress)="passDataInForm($event)">
					</fb-address-list>
				</ng-container>
			</ng-container>
		</div>
	</div>
</div>


<div class="add_address_cont {{isCheckoutPage?'for_checkout':''}}" *ngIf="isAddressPopupClosed">
	<button (click)="closeAddressPopup()">
		<span class="close material-symbols-outlined">close</span>
	</button>
	<fb-address-add class="add_address"
					[addressTypeData]="addressType" [addressData]="addressData"
					[shippingAddressLength]='shippingAddress.length'
					[billingAddressLength]='billingAddress.length'
					(addressSaved)="closeAddressPopup()">
	</fb-address-add>
</div>
